import React from 'react'
import ProductCheckInType from './ProductCheckInType'
import { fetchProducts, clearProduct } from '../../actions/remote_api'
import { connect } from 'react-redux'
import { debounce } from 'lodash'

class ProductCheckInTypeContainer extends React.Component {
  constructor(props) {
    super(props)
    this.fetchProducts = debounce(this.fetchProducts, 300)
  }

  fetchProducts = () => {
    const { serviceId, searchText } = this.props
    const query = {
      name_like: searchText,
      sort: 'name',
      order: 'asc',
      limit: 20,
    }

    if (serviceId) {
      query.serviceId = serviceId
    }

    this.props.fetchProducts(query)
  }

  handleFilterTextChange = (filterText) => {
    // Update parent's search state
    if (this.props.onSearchChange) {
      this.props.onSearchChange(filterText)
    }
    // Trigger debounced fetch
    this.fetchProducts()
  }

  componentDidMount() {
    // Always fetch fresh products when modal opens
    this.fetchProducts()
  }

  componentDidUpdate(prevProps) {
    // Re-fetch when searchText changes (from parent state)
    if (prevProps.searchText !== this.props.searchText) {
      this.fetchProducts()
    }
  }

  componentWillUnmount() {
    // Don't clear the product list - we need it to display the selected product name
    // The list will be refreshed when the modal reopens
  }

  render() {
    const { products, onProductSelect, searchText } = this.props
    return (
      <ProductCheckInType
        products={products}
        filterText={searchText}
        onFilterTextChange={this.handleFilterTextChange}
        onProductSelect={onProductSelect}
      />
    )
  }
}

export default connect(
  ({ fetch }) => ({
    products: fetch.product ? fetch.product.list : undefined,
  }),
  {
    fetchProducts,
    clearProduct,
  },
)(ProductCheckInTypeContainer)
